import { render, staticRenderFns } from "./DomainCard.vue?vue&type=template&id=3dc38a27&scoped=true"
import script from "./DomainCard.vue?vue&type=script&lang=js"
export * from "./DomainCard.vue?vue&type=script&lang=js"
import style0 from "./DomainCard.vue?vue&type=style&index=0&id=3dc38a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc38a27",
  null
  
)

export default component.exports